"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._ErrorDocument = {
    type: "structure",
    required: ["Key"],
    members: {
        Key: {
            shape: {
                type: "string",
                min: 1
            }
        }
    }
};
//# sourceMappingURL=_ErrorDocument.js.map